import { Popper, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles, withStyles } from "@material-ui/styles";
import { useEffect, useLayoutEffect, useState } from "react";
import Select from "react-dropdown-select";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { toast } from "react-toastify";
import { getCoverIdForExpiryDate } from "../store/businesslogic/hardwiredlogic";
import {
  getArrayOfResponseSelectedForCompare,
  getSTCoptionsInsurerSelected,
  getSTCoptionsReasonForRecommendation,
  updateStcOptionsInsurerSelected,
  updateStcOptionsReasonForRecommendation,
  updateStcOptionsTeamSelected,
  getCoverTable,
  getCoverTypes,
  getInsurerDetails,
  getResponseDetails,
  getProspectDetails,
  getCoversAndCoverTypesFromStore,
  getSTCoptionsCoversDynTableDetails,
  getResponseOrder,
  getSTCoptionsCoversDynTableOrder,
  updateSTCoptionSelectedValue,
  uploadInsurerCheckBoxValue,
  getPolicyJustBinded,
  getSTCoptionValue,
  getInsurerCheckboxValue,
  getSTCoptions,
  updateSTCOptionsToDB,
} from "../store/quotes";

import { getProspectDoc } from "../store/qf";

import { useLocation } from "react-router-dom";
import * as theme from "../theme";
import _ from "lodash";
import {
  DEFAULT_SELECTED_OPTION,
  getDefaultSelectedOption,
} from "../store/businesslogic/hardwiredlogic";
import InsurerCoverSelection from "./InsurerCoverSelection/InsurerCoverSelection";
import { getRowDetailsFromProspectId } from "../store/myquotes";
import { getLanguagePreference, getBrokerInformation } from "../store/broker";

const CustomOptionInsurerList = ({ optiontype }) => {
  const dispatch = useDispatch();
  const selectedinsurer = useSelector(getSTCoptionsInsurerSelected);
  const verticalId = useSelector(getResponseOrder);

  const { search } = useLocation();
  const prospectid = search.substring(4);
  const [prospectDetails, setProspectDetails] = useState(
    useSelector(getRowDetailsFromProspectId({ prospectid }))
  );

  const fullProspectData = useSelector(getProspectDoc);
  const brokerage = useSelector(getBrokerInformation);
  const languagecode = brokerage.information.languagepreference;

  // Translation object for different languages
  const translations = {
    en: {
      selectInsurer:
        "Please select the relevant insurer if you are recommending the quote to your client at this stage.",
      outlineReasons:
        "Please outline the reasons why this quote is being recommended. It will be shared with the client under the heading “Reason for Recommendation:”",
      filterCovers: "Filter Covers by their type:",
    },
    fr: {
      selectInsurer:
        "Veuillez sélectionner l'assureur concerné si vous recommandez le devis à votre client à ce stade.",
      outlineReasons:
        "Veuillez préciser les raisons pour lesquelles ce devis est recommandé. Il sera partagé avec le client sous le titre « Motif de la recommandation : »",
      filterCovers: "Filtrer les garanties par leur type :",
    },
  };

  useEffect(() => {
    // Fixes issue with missing prospect from table in getRowDetailsFromProspectId
    if (_.isEmpty(prospectDetails)) {
      setProspectDetails({ ...fullProspectData?.answers }); // Holds the answers for data related to vertical types
    }
  }, [prospectDetails]);

  const isDefaultOptionSelected = ({
    currentSelected,
    optionToCompareWith,
  }) => {
    return _.isEqual(optionToCompareWith, currentSelected);
  };

  return (
    <div
      style={{
        minHeight: "7vh",
        paddingLeft: "9vmin",
        fontSize: "1.5vmin",
        paddingTop: "1vh",
        width: "100%",
      }}
    >
      <span style={{ fontFamily: "GibsonLightIt" }}>
        {translations[languagecode]?.selectInsurer}
      </span>
      <InsRcmdDropDown />
      {/* Show this div only if option 1 (no recommendation) is not selected */}
      <div style={{ display: "flex", flexDirection: "column" }}>
        {selectedinsurer &&
        selectedinsurer === getDefaultSelectedOption(languagecode) ? null : (
          <>
            <span style={{ fontFamily: "GibsonLightIt" }}>
              {translations[languagecode]?.outlineReasons}
            </span>
            <InputForReason />
          </>
        )}
        <div style={{ height: "2vh" }}></div>
        <div style={{ marginBottom: "5px" }}>
          {translations[languagecode]?.filterCovers}
        </div>
        <InsurerCoverSelection
          prospectid={prospectid}
          prospectDetails={prospectDetails}
        />
      </div>
    </div>
  );
};

const InputForReason = () => {
  const reasonforrecommendation = useSelector(
    getSTCoptionsReasonForRecommendation
  );
  const [input, setInput] = useState(reasonforrecommendation);
  const dispatch = useDispatch();

  const handleAnswer = (event) => {
    dispatch(updateStcOptionsReasonForRecommendation({ value: input }));
  };

  const handleChange = (event) => {
    setInput(event.target.value);
  };

  return (
    <textarea
      type="text"
      id={"stringInput_reasonforRcmd"}
      style={{ ...theme.textAreaInputStyle, width: "100%", height: "17%" }}
      value={input}
      onChange={handleChange}
      onBlur={handleAnswer}
    ></textarea>
  );
};

const InsRcmdDropDown = () => {
  const dispatch = useDispatch();
  const optionlist = useSelector(getArrayOfResponseSelectedForCompare);

  const valuesfetch = useSelector(getSTCoptionsInsurerSelected);
  const selectedInsurer = optionlist?.some(
    (option) => option?.id === valuesfetch?.id
  );
  const brokerage = useSelector(getBrokerInformation);
  const languagecode = brokerage.information.languagepreference;
  useEffect(() => {
    if (!selectedInsurer)
      dispatch(
        updateStcOptionsInsurerSelected({
          selectedoption: getDefaultSelectedOption(languagecode),
        })
      );
  }, [!selectedInsurer]);

  const CssTextField = withStyles({
    root: {
      "& label.Mui-focused": {
        color: "white",
      },
      "& .MuiInput-underline:after": {
        borderBottomColor: "white",
      },
      "& .MuiInput-icon": {
        color: "white",
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "white",
        },
        "&:hover fieldset": {
          borderColor: "white",
        },
        "&.Mui-focused fieldset": {
          borderColor: "white",
        },
      },
    },
    icon: {
      color: "white",
    },
  })(TextField);

  const useStyles = makeStyles({
    root: {
      color: "white",
      width: "20vw",
      backgroundColor: theme.COLORS.primary_navyblue,
      fontFamily: "GibsonSemiBd",
      broder: "2px solid white",
      "& .MuiAutocomplete-listbox": {
        border: "2px solid grey",
        minHeight: 400,
        color: "green",
        fontSize: 18,
        //hover discussed above
        "& li": {
          //list item specific styling
          border: "2px solid green",
          borderRadius: 4,
        },
      },
    },
    outerRoot: {
      fontFamily: "GibsonSemiBd",
      border: 0,
      color: "white",
    },
    input: {
      color: "blue",
    },
    textfield: {
      "& .MuiButtonBase-root.MuiAutocomplete-clearIndicator": {
        color: "white",
      },
      "& .MuiButtonBase-root.MuiAutocomplete-popupIndicator": {
        color: "white",
      },
      "& .MuiInputBase-input.MuiAutocomplete-input": {
        color: "white",
      },
      "& #custom-autocomplete-label": {
        //or could be targeted through a class
        color: "brown",
      },
    },
  });
  const classes = useStyles();

  const onChangeHandle = (event, value) => {
    if (value)
      dispatch(updateStcOptionsInsurerSelected({ selectedoption: value }));

    if (_.isEqual(value, getDefaultSelectedOption(languagecode))) {
      // delete the reason for recommendation
      dispatch(updateStcOptionsReasonForRecommendation({ value: "" }));
    }
  };

  return (
    <div style={{ paddingTop: "1vmin", marginBottom: "2vmin" }}>
      <Autocomplete
        id={`RCMD`}
        options={optionlist}
        getOptionLabel={(option) => option?.text}
        onChange={onChangeHandle}
        value={
          !selectedInsurer
            ? getDefaultSelectedOption(languagecode)
            : valuesfetch
        }
        // PopperComponent={CustomPopper}
        classes={{
          root: classes.root,
        }}
        style={{ fontFamily: "GibsonSemiBd" }}
        renderInput={(params) => (
          <CssTextField
            {...params}
            variant="outlined"
            margin="dense"
            classes={{
              root: classes.root,
            }}
            className={classes.textfield}
            // onFocus={() => {
            //   if (helpTipPB.VerticalHelpOrTipFncs.changeText) {
            //     helpTipPB.VerticalHelpOrTipFncs.changeText(
            //       this.props.questionHint
            //     );
            //   }
            // }}
            // onBlur={() => {
            //   if (helpTipPB.VerticalHelpOrTipFncs.changeText) {
            //     helpTipPB.VerticalHelpOrTipFncs.changeText("");
            //   }
            // }}
          />
        )}
      ></Autocomplete>
    </div>
  );
};

export default CustomOptionInsurerList;
